<template>
    <button
        type="button"
        class="map-button"
        :class="{
            [`map-color-${color}`]: color,
            'map-round': round,
            'map-has-icon': icon || iconRight,
            'map-disabled': disabled,
            'map-label-button': isLink,
        }"
        >
        <slot name="loading">
            <i v-if="loading" class="map-loading"></i>
        </slot>
        <slot name="icon">
            <i v-if="icon" class="map-icon" :class="icon"></i>
        </slot>
        <slot></slot>
        <slot name="icon-right">
            <i v-if="iconRight" class="map-icon" :class="iconRight"></i>
        </slot>
    </button>
</template>

<script>
    export default
    {
        name: 'Button',
        props:
        {
            round: Boolean,
            color: String,
            icon: String,
            iconRight: String,
            loading: Boolean,
            disabled: Boolean,
            isLink:
            {
                type: Boolean,
                description: 'Whether button is a link (no background and borders)'
            },
        },
        methods:
        {
        },
    }
</script>
